import React from 'react';
import Header from './Header';
import FooterOther from './FooterOther';
import prevencao_e_saude from '../assets/images/Medsim210.png';

const preventionWorkerHealth = () => {
    return (
        <div>
            <Header />
            <img src={prevencao_e_saude} className="image-ajustada" style={{ width: '100%' }} alt="Prevenção & Saúde do Trabalhador" />
            <section className="request-proposal" id="solicitar-proposta">
                <div className="container-fluid">
                    <div className="row p-0 text-center">
                        <div className="col-12 title">Unidade de Prevenção & Saúde do Trabalhador</div>
                    </div>
                </div>
            </section>
            <section className="request-proposal-form" id="solicitar-proposta">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            A unidade móvel de serviços básicos de saúde é uma solução prática e acessível para levar cuidados essenciais diretamente ao local da sua empresa, evento ou comunidade. Com uma estrutura completa e preparada para uso imediato, oferece atendimento ágil e humanizado, promovendo a saúde e o bem-estar de forma prática e eficiente.
                        </div>
                        <div className="col-12 py-3">
                            Essa solução elimina barreiras de acesso aos serviços de saúde, proporcionando conforto e economia de tempo. Flexíveis e personalizáveis, as unidades atendem diversas demandas, desde consultas preventivas até ações educativas e de triagem, garantindo cuidado de qualidade para diferentes públicos.
                        </div>
                        <div className="col-12 py-3">
                            <strong>Exames e Serviços Disponíveis: </strong>
                        </div>
                        <div className="col-12 py-3">
                            <ul>
                                <li>Consultas Clínicas Básicas</li>
                                <li>Vacinação</li>
                                <li>Triagem de Sinais Vitais (Pressão Arterial, Glicemia, etc.)</li>
                                <li>Exames Laboratoriais Simples</li>
                                <li>Ações Educativas sobre Saúde Preventiva</li>
                                <li>Atendimento de Enfermagem</li>
                            </ul>
                        </div>
                        <div className="col-12 py-3">
                            Seja para atender empresas, comunidades ou eventos, a unidade móvel de serviços básicos de saúde é a escolha ideal para oferecer cuidado acessível e de qualidade onde for necessário.
                        </div>
                        <div className="col-3 py-2"> <a href="https://wa.me/556598106742" target="_blank" className="btn btn-warning text-uppercase d-block rounded-0 py-3"><strong>Quero Contratar</strong></a> </div>

                    </div>
                </div>
            </section>
            <FooterOther />
        </div>

    );
};

export default preventionWorkerHealth;